module.exports = __webpack_public_path__ + "media/images/linkedin-5f2b0e11149537ef6a21ebd1994a22ef.svg";